module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_morning-mix_wp_2016_07_07_minn-cop-fatally-shoots-man-during-traffic-stop-aftermath-broadcast-on-facebook__plot.a5ff5ce9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_07_07_minn-cop-fatally-shoots-man-during-traffic-stop-aftermath-broadcast-on-facebook__plot.png
// module id = 430
// module chunks = 0